import { NavLink } from "react-router-dom";
import styles from "./NavigationSidebar.module.css";

const NavigationSidebar = () => {
  return (
    <nav className={styles.navBlock} aria-label="settings-navigation">
      <h1 className={styles.mainTitle}>Configuración</h1>

      <h3 className={styles.subtitle}> Gestión de Datos</h3>
      <ul className={styles.navList}>
        <li className={styles.navListItem}>
          <NavLink
            to={"documents-library"}
            className={({ isActive }) =>
              isActive ? `${styles.link} ${styles.activeLink}` : styles.link
            }
          >
            Biblioteca de Documentos
          </NavLink>
        </li>
        <li className={styles.navListItem}>
          <NavLink
            to={"documents-export"}
            className={({ isActive }) =>
              isActive ? `${styles.link} ${styles.activeLink}` : styles.link
            }
          >
            Descarga de Documentos
          </NavLink>
        </li>
        <li className={styles.navListItem}>
          <NavLink
            to={"departments"}
            className={({ isActive }) =>
              isActive ? `${styles.link} ${styles.activeLink}` : styles.link
            }
          >
            Clasificación
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};

export default NavigationSidebar;
